/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_News_HintInputs */

const en_us2_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changed in recent versions`)
};

const pt_br2_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que mudou nas últimas versões`)
};

const es_419_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué cambió en las últimas versiones`)
};

const pt_pt2_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que mudou nas últimas versões`)
};

const fr_fr2_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui a changé dans les dernières versions`)
};

const de_de2_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sich in den letzten Versionen geändert hat`)
};

const it_it2_community_news_hint = /** @type {(inputs: Community_News_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa è cambiato nelle ultime versioni`)
};

/**
* | output |
* | --- |
* | "What changed in recent versions" |
*
* @param {Community_News_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_hint = /** @type {((inputs?: Community_News_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_hint(inputs)
	if (locale === "es-419") return es_419_community_news_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_hint(inputs)
	if (locale === "de-DE") return de_de2_community_news_hint(inputs)
	if (locale === "it-IT") return it_it2_community_news_hint(inputs)
	return en_us2_community_news_hint(inputs)
});
export { community_news_hint as "community.news_hint" }